import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const ModalContent = styled.div`
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
`;

export const Section = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.black || DEFAULT_COLORS.black};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  background-color: ${({ theme }) => theme.palette.grey5 || DEFAULT_COLORS.grey5};
  color: ${({ theme }) => theme.palette.primary || DEFAULT_COLORS.primary};
  border-radius: 14px;
  font-size: 14px;
  font-weight: 400;
`;

export const ClearLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.palette.primary || DEFAULT_COLORS.primary};
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxInput = styled.input`
  width: 20px;
  height: 20px;
  margin: 0;
  margin-right: 12px;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.palette.primary || DEFAULT_COLORS.primary};
`;

export const CheckboxLabel = styled.label`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.black || DEFAULT_COLORS.black};
  cursor: pointer;
  user-select: none;
`;

export const RadioGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioInput = styled.input`
  width: 20px;
  height: 20px;
  margin: 0;
  margin-right: 12px;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.palette.primary || DEFAULT_COLORS.primary};
`;

export const RadioLabel = styled.label`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.black || DEFAULT_COLORS.black};
  cursor: pointer;
  user-select: none;
`;

export const BottomActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding-top: 24px;
  gap: 16px;
`;
